import {ReactElement} from 'react';

import {RowRenderer} from '../RowRenderer';
import {RowType} from '../types/RowType';

export const generateInfoCardRows = (rows: RowType[]): ReactElement[] =>
  rows.map((row, index) => <RowRenderer key={row.key} row={row} index={index} />);
